import classNames from "classnames";
import { Badge } from "@payping/web-components";
import { FC } from "react";
import { LinkProps, Link as RRLink } from "react-router-dom";

import styles from "./styles.module.scss";

interface Props extends LinkProps {
  hasNotifyPoint?: boolean;
}

const Link: FC<Props> = ({ hasNotifyPoint = false, children, className, ...otherProps }) => (
  <RRLink {...otherProps} className={classNames(styles.container, className)}>
    <Badge className="align-center" dot={hasNotifyPoint}>
      {children}
    </Badge>
  </RRLink>
);
export default Link;
